import React, {useEffect, useState} from "react";
import {GROUP_PUBLIC} from "../../../utils/consts";
import {FormattedMessage} from "react-intl";

function SelectorSaveEdit({options, onSave, inputValue, label, inputLabel, alwaysEditing, required}) {

    let [value, setValue] = useState(inputValue);
    const [editing, setEditing] = useState(false);
    const [invalid, setInvalid]= useState(false);

    useEffect(() => {
        if(alwaysEditing){
            setEditing(true);
        }
        if (!inputValue) {
            setEditing(true);
        }
    }, []);

    const toggleEdit = () => {
        if (editing) {
            if(!value){
                setInvalid(true)
                if(alwaysEditing){
                    onSave(value);
                }
                return;
            }
            setInvalid(false);
            onSave(value);
        }
        if(!alwaysEditing){
            setEditing(!editing);
        }
    }
    return (
        <div className="col-12 d-flex flex-wrap">
            {label && <label style={{fontWeight: "bold"}} htmlFor="userInput">{label}{required && " *"}</label>}
            <div className={"input-group mb-1 col-12 " + (invalid && "is-invalid")}>
                <select value={value} className={"form-select " + (invalid && "is-invalid")} disabled={!editing}
                        onChange={e => {
                            setValue(e.target.value);
                            value = e.target.value;
                            if(alwaysEditing){
                                toggleEdit();
                            }
                        }}>
                    <option hidden={true}>{inputLabel ?? label}</option>
                    {
                        options.map(option => {
                            return <option key={option.code} value={option.code}>{option.label}</option>
                        })
                    }
                </select>
                {!alwaysEditing && <span style={{width: '42px', cursor: 'pointer'}}
                       className="input-group-text d-flex justify-content-center button-edit"
                       onClick={toggleEdit}>
                    {!editing && <i className="fa-solid fa-pen-to-square"/>}
                    {editing && <i className="fa-solid fa-floppy-disk"/>}
                </span>}
            </div>
            <div id="validationSelector" className="invalid-feedback">
                <FormattedMessage id="selector-save-edit.invalid-feedback"/>
            </div>
        </div>
    )

}

export default SelectorSaveEdit;
